import { BrokerPayerFields } from './BrokerPayerFields';
import { InsurancePayerFields } from './InsurancePayerFields';
import { PassengerPayerLinkSwitch } from './PassengerPayerLinkSwitch';
import { PayerSelect } from './PayerSelect';
import { usePricingFormContext } from './PricingFormContext';
import { useUserRoles } from 'src/features/auth/useUserRoles';
import { useIsRideOrderingPortalEnabledForOrganization } from 'src/features/rideOrderingPortal/useIsRideOrderingPortalEnabledForOrganization';

export function PricingFormBody() {
  const isRideOrderingPortalEnabledForOrganization =
    useIsRideOrderingPortalEnabledForOrganization();

  const { isRideOrderingPortalUser } = useUserRoles();

  const shouldShowPayerLinkSwitch =
    isRideOrderingPortalEnabledForOrganization && !isRideOrderingPortalUser;

  const { selectedPassenger, selectedPayer, hasIntermediary, onPayerSelected } =
    usePricingFormContext();
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <PayerSelect
        selectedPassenger={selectedPassenger}
        hasIntermediary={hasIntermediary}
        onPayerSelected={onPayerSelected}
      />
      {selectedPayer?.payer_type === 'broker' ? (
        <BrokerPayerFields selectedPayer={selectedPayer} />
      ) : null}
      {selectedPayer?.payer_type === 'insurance' ? (
        <InsurancePayerFields selectedPayer={selectedPayer} />
      ) : null}
      {shouldShowPayerLinkSwitch && <PassengerPayerLinkSwitch />}
    </div>
  );
}
